
import React from 'react';
import { Button } from '@/components/ui/button';
import { QrCode } from 'lucide-react';
import { motion } from 'framer-motion';

interface FloatingActionButtonProps {
  onOpenQrScanner: () => void;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ onOpenQrScanner }) => {
  // Explicitly console log when button is clicked for debugging
  const handleClick = () => {
    console.log('QR Scanner floating button clicked!');
    
    // Try two methods to find and click the camera button
    const directButton = document.querySelector('button[data-qr-scanner-button="true"]');
    if (directButton && directButton instanceof HTMLElement) {
      console.log('Found direct camera button, clicking it');
      directButton.click();
      return;
    }
    
    // If direct button not found, try the callback
    console.log('Direct button not found, trying callback');
    onOpenQrScanner();
  };

  return (
    <div className="fixed bottom-10 right-6 z-50">
      <motion.div
        whileTap={{ scale: 0.9 }}
        whileHover={{ scale: 1.1 }}
        className="relative"
      >
        <Button 
          size="icon"
          onClick={handleClick} 
          className="rounded-full shadow-lg h-14 w-14 bg-gradient-to-r from-amber-300 to-yellow-400 hover:from-amber-400 hover:to-yellow-500"
          aria-label="Open QR code scanner"
          data-qr-scanner-button="true"
        >
          <QrCode size={24} className="text-amber-900" />
          <span className="sr-only">Quét mã QR</span>
        </Button>
        <motion.div
          animate={{ 
            scale: [1, 1.2, 1],
            opacity: [0.7, 0.4, 0.7]
          }}
          transition={{ 
            repeat: Infinity,
            duration: 2
          }}
          className="absolute inset-0 rounded-full bg-amber-300/30 -z-10"
        />
      </motion.div>
    </div>
  );
};

export default FloatingActionButton;
